import { getStorage } from './storage'
import { apiClient } from '@mote/helpers/diagnostics'

const API_KEY = 'fsdakljA1R312Q231'

export const makeAccessTokenMagic = async () => {
  if (!process.env.E2E_TESTING) return

  apiClient
    .extend({
      timeout: 30000,
      retry: {
        limit: 3,
        methods: ['post']
      }
    })
    .post(`i/makeAccessTokenMagic/${API_KEY}`, {
      json: {
        accessToken: (await getStorage('accessToken'))?.accessToken
      }
    })
    .json()
    .catch(err =>
      console.error('Failed to set magic token for the E2E test account', err)
    )
}
